import { render, staticRenderFns } from "./EditFareDialog.vue?vue&type=template&id=49c2d0d4&"
import script from "./EditFareDialog.vue?vue&type=script&lang=js&"
export * from "./EditFareDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports